import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const services = [
  { icone: '🗄️', titre: 'Base de Données',         desc: 'Conception · Optimisation · Architecture' },
  { icone: '🌐', titre: 'Développement Web',        desc: 'Sites · Web Apps · E-commerce' },
  { icone: '📱', titre: 'Application Mobile',       desc: 'Android · iOS · Cross-platform' },
  { icone: '🔒', titre: 'Cybersécurité',            desc: 'Audit · Conseil · Protection' },
  { icone: '🔌', titre: 'Réseaux & Infrastructure', desc: 'LAN · Câblage · WiFi' },
  { icone: '⚡', titre: 'Installation Électrique',  desc: 'Câblage · Mise aux normes' },
  { icone: '💡', titre: 'Consultation IT',          desc: 'Modernisation · Amélioration' },
];

const budgets = [
  'Moins de 1 000 $',
  '1 000 $ – 5 000 $',
  '5 000 $ – 15 000 $',
  'Plus de 15 000 $',
  'À discuter',
];

const etapes = ['Vos infos', 'Votre projet', 'Budget & délai', 'Confirmation'];

function DemandeProjet() {
  const [etape, setEtape] = useState(0);
  const [envoye, setEnvoye] = useState(false);
  const [form, setForm] = useState({
    nom: '', prenom: '', email: '', telephone: '', entreprise: '',
    services: [], description: '', budget: '', deadline: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const toggleService = (titre) => {
    setForm(prev => ({
      ...prev,
      services: prev.services.includes(titre)
        ? prev.services.filter(s => s !== titre)
        : [...prev.services, titre],
    }));
  };

  const suivant = () => setEtape(e => Math.min(e + 1, 3));
  const precedent = () => setEtape(e => Math.max(e - 1, 0));

  const handleSubmit = async () => {
    try {
      const axios = (await import('axios')).default;
      await axios.post('https://efe-systems.com/api/devis', {
        nom_contact:        `${form.prenom} ${form.nom}`,
        email_contact:      form.email,
        telephone_contact:  form.telephone,
        entreprise_contact: form.entreprise,
        titre_projet:       form.services.join(', '),
        description_projet: form.description,
        services_demandes:  form.services,
        budget_estime:      form.budget,
        deadline_souhaitee: form.deadline || null,
      });
      setEnvoye(true);
    } catch (error) {
      console.error('Erreur:', error);
      alert('Une erreur est survenue. Vérifiez que le serveur Laravel est lancé.');
    }
  };

  const inputStyle = {
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)',
    color: 'white',
    borderRadius: '12px',
    padding: '12px 16px',
    width: '100%',
    outline: 'none',
    fontSize: '14px',
  };

  return (
    <div style={{ minHeight: '100vh', background: '#050510' }}>
      
      {/* Navbar */}
      <Navbar />

      {/* Hero Background */}
      <div
        className="w-full flex items-center justify-center px-6 pt-32 pb-16"
        style={{
          background: '#050510',
          backgroundImage: `
            radial-gradient(ellipse 80% 50% at 20% 40%, rgba(26,26,230,0.12) 0%, transparent 60%),
            radial-gradient(ellipse 60% 40% at 80% 60%, rgba(107,33,232,0.10) 0%, transparent 60%),
            linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)
          `,
          backgroundSize: 'auto, auto, 40px 40px, 40px 40px',
        }}
      >
        <div className="w-full max-w-2xl">

          {/* Titre page */}
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-4 py-1 rounded-full text-sm mb-4"
              style={{ background: 'rgba(26,26,230,0.1)', border: '1px solid rgba(26,26,230,0.3)', color: '#818CF8' }}>
              Démarrer un projet
            </div>
            <h1 className="text-4xl font-extrabold text-white mb-3">
              Parlons de votre <span style={{ color: '#F5C500' }}>projet</span>
            </h1>
            <p className="text-gray-400">
              Remplissez ce formulaire en 2 minutes — nous vous répondons sous 24h.
            </p>
          </div>

          {/* Carte principale */}
          <div className="w-full rounded-3xl p-8 md:p-10"
            style={{
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.08)',
              backdropFilter: 'blur(20px)',
            }}>

            {!envoye ? (
              <>
                {/* Barre de progression */}
                <div className="flex items-center justify-between mb-10">
                  {etapes.map((label, i) => (
                    <div key={i} className="flex flex-col items-center gap-1 flex-1">
                      <div className="flex items-center w-full">
                        {i > 0 && (
                          <div className="flex-1 h-0.5 transition-all duration-300"
                            style={{ background: i <= etape ? '#1A1AE6' : 'rgba(255,255,255,0.1)' }}>
                          </div>
                        )}
                        <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all duration-300 flex-shrink-0"
                          style={{
                            background: i < etape ? '#1A1AE6' : i === etape ? '#F5C500' : 'rgba(255,255,255,0.08)',
                            color: i <= etape ? 'white' : 'rgba(255,255,255,0.3)',
                            border: i === etape ? '2px solid #F5C500' : 'none',
                          }}>
                          {i < etape ? '✓' : i + 1}
                        </div>
                        {i < etapes.length - 1 && (
                          <div className="flex-1 h-0.5 transition-all duration-300"
                            style={{ background: i < etape ? '#1A1AE6' : 'rgba(255,255,255,0.1)' }}>
                          </div>
                        )}
                      </div>
                      <span className="text-xs text-center hidden md:block"
                        style={{ color: i === etape ? '#F5C500' : 'rgba(255,255,255,0.3)' }}>
                        {label}
                      </span>
                    </div>
                  ))}
                </div>

                {/* ÉTAPE 1 */}
                {etape === 0 && (
                  <div className="flex flex-col gap-4">
                    <h2 className="text-white text-2xl font-extrabold mb-2">Parlez-nous de vous</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="text-gray-400 text-xs mb-1 block">Prénom *</label>
                        <input name="prenom" value={form.prenom} onChange={handleChange}
                          placeholder="Jean" style={inputStyle} />
                      </div>
                      <div>
                        <label className="text-gray-400 text-xs mb-1 block">Nom *</label>
                        <input name="nom" value={form.nom} onChange={handleChange}
                          placeholder="Pierre" style={inputStyle} />
                      </div>
                    </div>
                    <div>
                      <label className="text-gray-400 text-xs mb-1 block">Email *</label>
                      <input name="email" value={form.email} onChange={handleChange}
                        placeholder="jean@exemple.com" style={inputStyle} />
                    </div>
                    <div>
                      <label className="text-gray-400 text-xs mb-1 block">Téléphone</label>
                      <input name="telephone" value={form.telephone} onChange={handleChange}
                        placeholder="+509 XXXX XXXX" style={inputStyle} />
                    </div>
                    <div>
                      <label className="text-gray-400 text-xs mb-1 block">Organisation / Entreprise</label>
                      <input name="entreprise" value={form.entreprise} onChange={handleChange}
                        placeholder="Nom de votre organisation" style={inputStyle} />
                    </div>
                  </div>
                )}

                {/* ÉTAPE 2 */}
                {etape === 1 && (
                  <div className="flex flex-col gap-6">
                    <h2 className="text-white text-2xl font-extrabold mb-2">Votre projet</h2>
                    <div>
                      <label className="text-gray-400 text-xs mb-3 block">
                        Sélectionnez le ou les services souhaités *
                      </label>
                      <div className="grid grid-cols-2 gap-3">
                        {services.map((s, i) => (
                          <div
                            key={i}
                            onClick={() => toggleService(s.titre)}
                            className="cursor-pointer rounded-2xl p-4 transition-all duration-200"
                            style={{
                              background: form.services.includes(s.titre) ? 'rgba(26,26,230,0.2)' : 'rgba(255,255,255,0.04)',
                              border: `1px solid ${form.services.includes(s.titre) ? '#1A1AE6' : 'rgba(255,255,255,0.08)'}`,
                            }}
                          >
                            <p className="text-lg mb-1">{s.icone}</p>
                            <p className="text-white text-xs font-bold">{s.titre}</p>
                            <p className="text-gray-500 text-xs">{s.desc}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div>
                      <label className="text-gray-400 text-xs mb-1 block">Décrivez votre projet *</label>
                      <textarea
                        name="description"
                        value={form.description}
                        onChange={handleChange}
                        rows={4}
                        placeholder="Décrivez votre besoin, vos objectifs..."
                        style={{ ...inputStyle, resize: 'none' }}
                      />
                    </div>
                  </div>
                )}

                {/* ÉTAPE 3 */}
                {etape === 2 && (
                  <div className="flex flex-col gap-6">
                    <h2 className="text-white text-2xl font-extrabold mb-2">Budget & délai</h2>
                    <div>
                      <label className="text-gray-400 text-xs mb-3 block">Budget estimé</label>
                      <div className="flex flex-col gap-2">
                        {budgets.map((b, i) => (
                          <div
                            key={i}
                            onClick={() => setForm({ ...form, budget: b })}
                            className="cursor-pointer px-4 py-3 rounded-xl transition-all duration-200 text-sm font-medium"
                            style={{
                              background: form.budget === b ? 'rgba(26,26,230,0.2)' : 'rgba(255,255,255,0.04)',
                              border: `1px solid ${form.budget === b ? '#1A1AE6' : 'rgba(255,255,255,0.08)'}`,
                              color: form.budget === b ? 'white' : 'rgba(255,255,255,0.6)',
                            }}
                          >
                            {form.budget === b ? '✓ ' : ''}{b}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div>
                      <label className="text-gray-400 text-xs mb-1 block">Délai souhaité</label>
                      <input
                        type="date"
                        name="deadline"
                        value={form.deadline}
                        onChange={handleChange}
                        style={{ ...inputStyle, colorScheme: 'dark' }}
                      />
                    </div>
                  </div>
                )}

                {/* ÉTAPE 4 */}
                {etape === 3 && (
                  <div className="flex flex-col gap-4">
                    <h2 className="text-white text-2xl font-extrabold mb-2">Récapitulatif</h2>
                    <div className="rounded-2xl p-5 flex flex-col gap-3"
                      style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-400">Nom</span>
                        <span className="text-white font-medium">{form.prenom} {form.nom}</span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-400">Email</span>
                        <span className="text-white font-medium">{form.email}</span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-400">Téléphone</span>
                        <span className="text-white font-medium">{form.telephone || '—'}</span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-400">Organisation</span>
                        <span className="text-white font-medium">{form.entreprise || '—'}</span>
                      </div>
                      <div className="border-t border-white/10 pt-3">
                        <span className="text-gray-400 text-sm">Services</span>
                        <div className="flex flex-wrap gap-2 mt-2">
                          {form.services.map((s, i) => (
                            <span key={i} className="px-3 py-1 rounded-full text-xs text-white"
                              style={{ background: '#1A1AE6' }}>{s}</span>
                          ))}
                        </div>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-400">Budget</span>
                        <span className="text-white font-medium">{form.budget || '—'}</span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-400">Délai</span>
                        <span className="text-white font-medium">{form.deadline || '—'}</span>
                      </div>
                    </div>
                    <p className="text-gray-500 text-xs text-center">
                      En soumettant ce formulaire, vous acceptez d'être contacté par EFE Systems.
                    </p>
                  </div>
                )}

                {/* Boutons navigation */}
                <div className="flex justify-between mt-8 gap-4">
                  {etape > 0 && (
                    <button onClick={precedent}
                      className="px-6 py-3 rounded-xl text-sm font-semibold transition hover:opacity-80"
                      style={{ background: 'rgba(255,255,255,0.06)', color: 'white', border: '1px solid rgba(255,255,255,0.1)' }}>
                      ← Précédent
                    </button>
                  )}
                  <div className="flex-1" />
                  {etape < 3 ? (
                    <button onClick={suivant}
                      className="px-8 py-3 rounded-xl text-sm font-semibold transition hover:opacity-90"
                      style={{ background: '#1A1AE6', color: 'white' }}>
                      Suivant →
                    </button>
                  ) : (
                    <button onClick={handleSubmit}
                      className="px-8 py-3 rounded-xl text-sm font-semibold transition hover:opacity-90"
                      style={{ background: '#F5C500', color: '#050510' }}>
                      Envoyer la demande ✓
                    </button>
                  )}
                </div>
              </>
            ) : (
              /* Message de succès */
              <div className="text-center py-10">
                <div className="text-6xl mb-6">✅</div>
                <h2 className="text-white text-2xl font-extrabold mb-3">
                  Demande envoyée !
                </h2>
                <p className="text-gray-400 mb-8">
                  Merci {form.prenom} ! Notre équipe vous contactera sous 24h.
                </p>
                <Link to="/"
                  className="px-8 py-3 rounded-xl text-sm font-semibold transition hover:opacity-90 inline-block"
                  style={{ background: '#1A1AE6', color: 'white', textDecoration: 'none' }}>
                  Retour à l'accueil
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />

    </div>
  );
}

export default DemandeProjet;